import { useQuery } from "@tanstack/react-query";

import { caaOrderQuery } from "../graphql/customer-account-gql";
import type { ICaaOrder, ICaaOrderQuery } from "../types/api/customer-account";
import type { TCaaRequestFn } from "../types/graphql";

interface IOrderReturn {
  order: ICaaOrder | null;
  loading: boolean;
  orderNotFound: boolean;
}

/**
 * Customer Account API 전용 useFindOrder.
 * CAA는 order(id:)로 단건 조회가 되므로 classic처럼 주문 목록(250개)을 뒤질 필요가 없다.
 */
export default function useFindOrderCaa({ orderId, request }: { orderId?: string; request: TCaaRequestFn }): IOrderReturn {
  const { data, isLoading, isFetched } = useQuery({
    queryKey: ["shopify", "caa-order", orderId],
    queryFn: () => request<ICaaOrderQuery>(caaOrderQuery, { id: `gid://shopify/Order/${orderId}` }),
    enabled: Boolean(orderId),
  });

  const order = data?.order ?? null;
  // isFetching 대신 isLoading/isFetched 로 판단해 백그라운드 refetch 중에 로딩/notFound가 깜빡이지 않게 한다
  const orderNotFound = Boolean(orderId) && isFetched && !order;

  return { order, loading: Boolean(orderId) && isLoading, orderNotFound };
}
